module.exports = __webpack_public_path__ + "static/media/todo.a2a3ec02.png";